export enum BusinessHealthCoverageSystem {
  BASIC = 'BASIC',
  IMPROVED = 'IMPROVED',
}

export const BUSINESS_HEALTH_COVERAGE_SYSTEM_VALUES = Object.values(
  BusinessHealthCoverageSystem
);

export const getBusinessHealthCoverageSystemLabel = (
  value: BusinessHealthCoverageSystem
) => {
  switch (value) {
    case BusinessHealthCoverageSystem.BASIC:
      return $localize`Standard`;
    case BusinessHealthCoverageSystem.IMPROVED:
      return $localize`Amélioré`;
  }
};
